import styled from 'styled-components';
import { devices, theme } from '@/styles/theme/index.jsx';

export const StyledBlogList = styled.div`
    background: ${theme.colors.themeColor5};
    position: relative;
    overflow: hidden;
    padding-top: 120px;
    margin-top: -1px;
    padding-bottom: 90px;
    &.forPage {
        padding-top: 95px;
        .blog-single-item-open {
            margin-bottom: 30px;
        }
        ${devices.sm} {
            padding-bottom: 95px;
        }
    }

    &.limit {
        padding-bottom: 0;
    }

    .blog-single-item-open {
        ${devices.ResponsiveTab} {
            width: 50%;
        }
    }
    ${devices.sm} {
        padding-bottom: 0;
        .blog-single-item-open {
            margin-bottom: 30px;

            &:last-child {
                margin: 0;
            }
        }
    }

`;